(function ($) {
    const slider = $(".featured-posts-slider");
    const image = document.querySelectorAll(".img-anim__wrapper-slider");
    const sliderItem = document.querySelectorAll(".post-item");


    document.addEventListener("aos:in", ({ detail }) => {
        if (detail.classList.contains("img-anim__wrapper-slider")) {
            const ovarlay = detail.querySelector(".img-anim__overlay-slider");
            const img = detail.querySelector(".img-anim__img-slider");

            if (detail.classList.contains("img-anim__wrapper-delay-slider")) {
                setTimeout(() => {
                    ovarlay.classList.add("active");
                    setTimeout(() => {
                        img.classList.add("active");
                    }, 800);
                }, 800);
            } else {
                ovarlay.classList.add("active");
                setTimeout(() => {
                    img.classList.add("active");
                }, 800)
            }
        }
    });

    document.addEventListener("aos:out", ({ detail }) => {
        if (detail.classList.contains("img-anim__wrapper-slider")) {
            const ovarlay = detail.querySelector(".img-anim__overlay-slider");
            const img = detail.querySelector(".img-anim__img-slider");

            if (detail.classList.contains("img-anim__wrapper-delay-slider")) {
                setTimeout(() => {
                    ovarlay.classList.remove("active");
                    img.classList.remove("active");
                }, 800);
            } else {
                ovarlay.classList.remove("active");
                img.classList.remove("active");
            }
        }
    });

    slider.slick({
        arrows: false,
        dots: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 5000,
        draggable: false,
        pauseOnFocus: false,
        pauseOnHover: false,
        fade: true,
        cssEase: "linear"
    });

    slider.on("touchstart", e => {
        slider.slick("slickPlay");
    });

    // On before slide change
    slider.on("beforeChange", function (event, slick, currentSlide, nextSlide) {
        image.forEach(function (imageWrap) {
            const ovarlay = imageWrap.querySelector(".img-anim__overlay-slider");
            const img = imageWrap.querySelector(".img-anim__img-slider");
            ovarlay.classList.remove("active");
            img.classList.remove("active");
        });

        sliderItem.forEach(function (item) {
            const date = item.querySelector(".date");
            const button = item.querySelector(".button-wrap");
            const title = item.querySelector(".text-anim-title");
            date.classList.remove("aos-animate");
            button.classList.remove("aos-animate");
            title.classList.remove("aos-animate");
        })
    });

    slider.on("afterChange", function (event, slick, currentSlide) {
        image.forEach(function (imageWrap) {
            const ovarlay = imageWrap.querySelector(".img-anim__overlay-slider");
            const img = imageWrap.querySelector(".img-anim__img-slider");
            ovarlay.classList.add("active");
            img.classList.add("active");
        });

        sliderItem.forEach(function (item) {
            const date = item.querySelector(".date");
            const button = item.querySelector(".button-wrap");
            const title = item.querySelector(".text-anim-title");
            date.classList.add("aos-animate");
            button.classList.add("aos-animate");
            title.classList.add("aos-animate");
        })
    });
})(jQuery);